module.exports = __webpack_public_path__ + "img/sphere02-graph.8b79ed5d.png";